import { IDrugsApiState } from '../types/drugs.types';

export const DRUGS_INITIAL_STATE: IDrugsApiState = {
    data: {
        list: [],
        totalPages: 0,
        totalRecords: 0,
    },
    pageProps: {
        isDescending: false,
        pageNumber: 0,
        perPage: 0,
        searchText: '',
        sortingOn: '',
    },
    drugsList: [],
    loading: 'idle',
    error: null,
};
